import bigInt from 'big-integer'

// initial state
const state = {
  err: null,
  requests: []
}

// getters
const getters = {
  RequestError: state => state.err,
  Requests: state => state.requests
}

// actions
const actions = {
  requestError ({commit}, data) {
    commit('setRequestError', data.data)
  },
  getRequests ({commit}, data) {
    commit('setRequests', data.data)
  }
}

// mutations
const mutations = {
  setRequestError (state, error) {
    state.err = {error: error, time: Date.now()}
  },
  setRequests (state, data) {
    state.requests = []
    for (let r in data) {
      let item = data[r]
      try {
        item.data = JSON.parse(item.data)
      } catch (e) {
        // Keep as string if not JSON
      }
      item.type = bigInt(item.type)
      state.requests[r] = item
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
